import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupGoalsLoadAction, UpdatePinnedGoalsForGroupFulfilledAction } from '../../domains/groupGoals/actions.types';
import { Goal, GoalsContext, Group } from '../types';

import { GroupGoals } from './types';

export type GroupGoalsActions = GroupGoalsLoadAction | UpdatePinnedGoalsForGroupFulfilledAction;

export const initialState: GroupGoals = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const optimisticallyUpdatePinnedGoals = (
  state: GroupGoals,
  groupId: Group['id'],
  goalsContext: GoalsContext,
  goalsOkrItemIds: Goal['id'][]
) => {
  const entities = {
    [groupId]: {
      id: groupId,
      goalsContextReference: { id: goalsContext.id, schema: goalsContext.__typename },
      goals: goalsOkrItemIds.map((id) => ({ nodeId: id })),
    },
  };

  return moveToFulfilled(state, entities);
};

const reducer: Reducer<GroupGoals, GroupGoalsActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_GOALS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_GOALS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupGoals);
    case 'GROUP_GOALS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_GOALS.UPDATE_PINNED_GOALS_FULFILLED':
      return optimisticallyUpdatePinnedGoals(
        state,
        action.payload.groupId,
        action.payload.goalsContext,
        action.payload.goalsOkrItems
      );
    default:
      return state;
  }
};

export default reducer;
